(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["grapesjs-rte-extensions"] = factory();
	else
		root["grapesjs-rte-extensions"] = factory();
})(window, function() {
return 